module.exports = __webpack_public_path__ + "img/veranito_movil.42fb4503.jpg";